export default "__VITE_ASSET__CKhxC7wd__"